import type { deDialer } from './de.dialer';

/** Türkçe çevirici metinleri. Referans: de.dialer.ts */
export const trDialer: Record<keyof typeof deDialer, string> = {
  'dialer.poolTitle': 'Çağrı al',
  'dialer.poolHint': 'Hazır olduğunuzda sistem sizin için arar ve açan müşterilere bağlar.',
  'dialer.assignedTitle': 'Kendi kayıtlarınızı ara',
  'dialer.assignedHint': 'Sistem kendi kayıtlarınızı sırayla arar.',

  'dialer.acceptCalls': 'Çağrı al',
  'dialer.start': 'Çeviriciyi başlat',
  'dialer.stop': 'Çeviriciyi durdur',
  'dialer.stopAccepting': 'Hazır durumu bitir',
  'dialer.pause': 'Mola',
  'dialer.resume': 'Devam et',
  'dialer.pauseHint': 'Moladan sonra yeniden bilerek hazır olmanız gerekir.',

  'dialer.state.OFFLINE': 'Hazır değil',
  'dialer.state.ONLINE': 'Hazır değil',
  'dialer.state.AVAILABLE': 'Hazır',
  'dialer.state.DIALING': 'Arıyor',
  'dialer.state.RINGING': 'Çalıyor',
  'dialer.state.IN_CALL': 'Görüşmede',
  'dialer.state.WRAP_UP': 'Son işlemler',
  'dialer.state.PAUSED': 'Molada',
  'dialer.state.RECONNECTING': 'Bağlantı yeniden kuruluyor',

  'dialer.manualTitle': 'Tek arama yap',
  'dialer.manualHint': 'Çeviriciden bağımsız tek bir arama için.',
  'dialer.manualBlocked': 'Tek arama yapmak için önce hazır durumunu bitirin.',

  'dialer.runtimeTitle': 'Bu kampanyadaki aramalar',
  'dialer.runtimeCallers': 'Hazır temsilci',
  'dialer.runtimeWaiting': 'Bekleyen müşteri',
  'dialer.runtimeIdle': 'Şu anda bu kampanyada kimse görüşme yapmıyor.',
  'dialer.help.waiting':
    'Telefonu açmış ve boş bir temsilci bekleyen müşteriler. Bu süre ücretlendirilmez.',

  'queueMusic.title': 'Bekleme müziği',
  'queueMusic.hint': 'Kampanya başına bir ses dosyası, WAV veya MP3, en fazla 5 MB. Döngüyle çalınır.',
  'queueMusic.upload': 'Dosya seç',
  'queueMusic.current': 'Kayıtlı',
  'queueMusic.remove': 'Kaldır',
  'queueMusic.none': 'Kendi bekleme müziğiniz kayıtlı değil.',
  'queueMusic.saved': 'Bekleme müziği kaydedildi.',

  'error.campaign.stopped': 'Bu kampanya durduruldu. Lütfen yöneticinizle görüşün.',
  'error.campaign.calls_in_progress':
    'Bu kampanyada şu anda görüşme yapılıyor. Lütfen görüşmeler bitene kadar bekleyin.',
  'error.queueMusic.empty': 'Lütfen bir ses dosyası seçin.',
  'error.queueMusic.too_large': 'Dosya çok büyük. En fazla 5 MB olabilir.',
  'error.queueMusic.invalid_format': 'Lütfen WAV veya MP3 dosyası yükleyin.',
};
